module.exports = __webpack_public_path__ + "img/fresh.d4df7fdf.png";